module.exports = __webpack_public_path__ + "static/media/0.dc008997.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/nose/0.png
// module id = 1379
// module chunks = 0